/**
 * Parse timestamp string from backend, ensuring correct timezone handling
 * Backend sends ISO strings that should be treated as UTC if no timezone specified
 */
export function parseTimestamp(timestamp: string | Date): Date {
  if (timestamp instanceof Date) {
    return timestamp
  }
  
  // If timestamp is ISO format without timezone, ensure it's treated as UTC
  // Backend typically sends: "2025-11-04T12:16:00" or "2025-11-04T12:16:00.000000"
  // We need to ensure proper parsing
  let dateStr = timestamp
  
  // If it's ISO format without Z or timezone offset, add Z to treat as UTC
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(dateStr) && !/[+-]\d{2}:\d{2}|Z$/.test(dateStr)) {
    // Remove microseconds if present and add Z
    dateStr = dateStr.split('.')[0] + 'Z'
  }
  
  return new Date(dateStr)
}

/**
 * Utility function to format date in IST (Indian Standard Time) format
 * Format: "Nov 3, 2025, 11:11 AM"
 */
export function formatISTDate(date: Date | string): string {
  const d = typeof date === 'string' ? parseTimestamp(date) : date
  
  return d.toLocaleString('en-US', {
    timeZone: 'Asia/Kolkata',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
}

/**
 * Format date for display in chat messages (shorter format)
 * Format: "Nov 3, 2025, 11:11 AM"
 */
export function formatChatDate(date: Date | string): string {
  return formatISTDate(date)
}

/**
 * Format date for admin panel display
 * Format: "Nov 3, 2025, 11:11 AM"
 */
export function formatAdminDate(date: Date | string): string {
  return formatISTDate(date)
}
